var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39058 13.3886C7.13023 13.649 7.13023 14.0711 7.39058 14.3314C7.65092 14.5918 8.07303 14.5918 8.33338 14.3314L12.8048 9.86003L8.33338 5.38862C8.07303 5.12827 7.65092 5.12827 7.39057 5.38862C7.13023 5.64897 7.13023 6.07108 7.39057 6.33143L10.9192 9.86003L7.39058 13.3886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.8b5fd4ab56f5db1936f4c9e2e706902d.svg";
export { ForwardRef as ReactComponent };